import { render, staticRenderFns } from "./one_page_module.vue?vue&type=template&id=2fc7ce80&scoped=true&"
import script from "./one_page_module.vue?vue&type=script&lang=js&"
export * from "./one_page_module.vue?vue&type=script&lang=js&"
import style0 from "./one_page_module.vue?vue&type=style&index=0&id=2fc7ce80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7ce80",
  null
  
)

export default component.exports